import type { BaseKeyFunction } from "../../../lib";

export const keyGiftDetails: BaseKeyFunction<{ promoCode: string }> = ({
  promoCode,
}) => ["gift-details", promoCode];
